import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { canAccess } from "@/config/roleViews";

/** Where a job opens: its page, optionally on a tab (overview, production_flow, materials, …). */
export function jobPath({ id, number, tab, stage }) {
  const params = new URLSearchParams();
  if (tab) params.set("tab", tab);
  if (stage) params.set("stage", stage);
  const query = params.toString() ? `?${params}` : "";
  return id ? `/orders/${id}${query}` : `/orders/no/${encodeURIComponent(number)}${query}`;
}

/** The stores view of a BPR: its issues and returns. */
export const bprMovementsPath = (number) => `/inventory?tab=movements&type=issue&q=${encodeURIComponent(number)}`;

/**
 * A job reference that opens the job. Stores documents and reports often know only
 * the BPR / MPWO number; those links resolve the number when clicked (pages/JobByNumber).
 * Views without the Jobs pages (stores keeper) land on the BPR's stores movements instead.
 * `newTab` keeps the current screen (an import preview, a half-filled form) open.
 */
export default function JobLink({ id, number, tab, stage, newTab = false, className = "", title, children }) {
  const { user } = useAuth();
  if (!id && !number) return <span className="text-neutral-300">—</span>;
  const canOpenJob = canAccess(user, "/orders");
  if (!canOpenJob && !number) return <span className={className}>{children}</span>;
  const to = canOpenJob ? jobPath({ id, number, tab, stage }) : bprMovementsPath(number);
  return (
    <Link
      to={to}
      {...(newTab && { target: "_blank", rel: "noopener noreferrer" })}
      title={title || (canOpenJob ? `Open job ${number || ""}`.trim() : `Stores movements for ${number}`)}
      onClick={(e) => e.stopPropagation()}
      className={`hover:text-[#FF5A00] hover:underline underline-offset-2 ${className}`}
    >
      {children ?? number}
    </Link>
  );
}
